import React from 'react';
import styled from 'styled-components';
import { mq, Title, CheckIcon, BodyText, BodyLink } from '@kvdbil/components';
import { SellFlowStepRecord } from '~/config/generated/graphql';
import { Image } from 'react-datocms';

const Header = styled(Title)`
  padding-bottom: 2rem;
  text-align: center;
`;

const Steps = styled.ol`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  gap: 2rem 1.5rem;

  ${mq('tablet')} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mq('laptop')} {
    grid-template-columns: repeat(4, 1fr);
  }

  img {
    width: 100%;
  }
`;

const ItemNumber = styled(BodyLink)`
  padding-right: 0.75em;
`;

const ItemHeading = styled(BodyLink)`
  display: inline;
`;

const BulletList = styled.ul`
  padding: 0.5rem 0;
  display: grid;
  row-gap: 0.5rem;
`;

const BulletListItem = styled.li`
  display: grid;
  align-items: center;
  grid-template-columns: max-content auto;
  column-gap: 0.5rem;

  svg {
    font-size: 0.75rem;
  }
`;

interface Props {
  title: string;
  items: SellFlowStepRecord[];
}

const SellCarSteps = ({ title, items }: Props) => (
  <div>
    <Header as="h2">{title}</Header>
    <Steps>
      {items &&
        items?.map((item, index) => {
          const image = item?.image;
          return (
            <li key={item?.title}>
              {image?.responsiveImage && (
                <Image
                  data={image?.responsiveImage}
                  style={{ maxWidth: '100%' }}
                />
              )}
              <ItemNumber as="span">{Number(index) + 1}</ItemNumber>
              <ItemHeading as="h3">{item?.title}</ItemHeading>
              <BulletList>
                {item?.step?.map((bullet, key) => (
                  <BulletListItem key={key}>
                    <CheckIcon />
                    <BodyText as="span">{bullet?.text}</BodyText>
                  </BulletListItem>
                ))}
              </BulletList>
            </li>
          );
        })}
    </Steps>
  </div>
);

export default SellCarSteps;
